import React, { Component } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { connect } from 'redux-scaffolding-ts';
import { Button, Container, Form, Message, Modal, Dimmer, Loader } from 'semantic-ui-react';
import {
  NewNMTrainingNameStore,
  CreateNMTrainingNameDto
} from 'stores/configuration/events-n-requests/non-machine-related/training-names-store';
import { isNullOrWhiteSpaces, formStoreHandler } from 'utils/useful-functions';
import NMFunctionalAreaEditor from 'widgets/bussiness/functional-area-editor';
import { ItemReference } from 'stores/dataStore';
import NMClusterEditor from 'widgets/bussiness/cluster-editor';
import CategoryFormEditor from 'widgets/bussiness/category-form-editor';
import { Categories } from 'stores/requests/requests-store';

interface NewNMTrainingNameViewProps extends WithTranslation {
  onClose: (isSuccess: boolean) => void;
  newNMTrainingName?: NewNMTrainingNameStore;
}

interface NewNMTrainingNameViewState {
  userClickedSave: boolean;
  functionalAreaName: ItemReference;
  cluster: ItemReference;
  category: Categories;
}

@connect(['newNMTrainingName', NewNMTrainingNameStore])
class NewNMTrainingNameView extends Component<NewNMTrainingNameViewProps, NewNMTrainingNameViewState> {
  constructor(props: NewNMTrainingNameViewProps) {
    super(props);
    this.props.newNMTrainingName.createNew({ name: '', functionalAreaId: '' });
    this.state = { category: Categories.Technical, functionalAreaName: null, cluster: null, userClickedSave: false };
  }

  private onCreateNewItem = async () => {
    this.setState({ userClickedSave: true });
    const result = await this.props.newNMTrainingName.submit();
    result?.isSuccess && this.props.onClose(true);
  };

  private onCancelNewItem = () => {
    this.props.newNMTrainingName.clear();
    this.props.onClose(false);
  };

  categoryChangeHandler = (category: Categories) => this.setState({ category, cluster: null, functionalAreaName: null });

  public render() {
    const { t, newNMTrainingName } = this.props;
    const { category, cluster, functionalAreaName, userClickedSave } = this.state;

    return (
      <Modal open closeOnEscape={true} onClose={this.onCancelNewItem} closeOnDimmerClick={false}>
        <Dimmer active={newNMTrainingName.state.isBusy} style={{ background: 'rgba(0, 0, 0, 0.4)' }}>
          <Loader indeterminate>{t('')}</Loader>
        </Dimmer>
        <Modal.Header className="modal__header">{t('New Training Name')}</Modal.Header>
        <Modal.Content image>
          <Container>
            {newNMTrainingName.state.result && !newNMTrainingName.state.result.isSuccess && (
              <Message
                className="error-message__style"
                icon="exclamation circle"
                error
                header={t('An error ocurred')}
                list={newNMTrainingName.state.result.messages.map(o => o.body)}
              />
            )}
            {newNMTrainingName.state.item && (
              <Form>
                <Form.Group widths="equal">
                  <Form.Input
                    required
                    fluid
                    error={!newNMTrainingName.state.item.name && userClickedSave}
                    label={t('Training Name')}
                    placeholder={t('Name')}
                    value={newNMTrainingName.state.item.name}
                    onChange={(_, { value }) => formStoreHandler<CreateNMTrainingNameDto>(newNMTrainingName, 'name', value)}
                  />
                  <Form.Field required>
                    <div className={`required field`}>
                      <label>{t('Cluster')}</label>
                      <NMClusterEditor
                        placeholder={t('Cluster')}
                        nullable
                        value={cluster}
                        category={category}
                        onChange={cluster => this.setState({ cluster })}
                      />
                    </div>
                  </Form.Field>
                  <Form.Field required>
                    <div
                      className={`required ${
                        isNullOrWhiteSpaces(newNMTrainingName.state.item.functionalAreaId) && userClickedSave ? 'error' : ''
                      } field`}
                    >
                      <label>{t('Functional Area')}</label>
                      <NMFunctionalAreaEditor
                        placeholder={t('Functional Area')}
                        nullable
                        readonly={!cluster}
                        clusterId={cluster?.id}
                        value={functionalAreaName}
                        onChange={c => formStoreHandler<CreateNMTrainingNameDto>(newNMTrainingName, 'functionalAreaId', c?.id)}
                      />
                    </div>
                  </Form.Field>
                </Form.Group>
              </Form>
            )}
          </Container>
        </Modal.Content>
        <div className="custom-actions">
          <Form.Field>
            <label>{t('Category')}</label>
            <CategoryFormEditor
              placeholder={t('Filter by Category')}
              className="form__header__dropdown-style"
              value={category}
              onChange={this.categoryChangeHandler}
            />
          </Form.Field>
          <Modal.Actions>
            <Button onClick={this.onCancelNewItem} basic>
              {t('Cancel')}
            </Button>
            <Button onClick={this.onCreateNewItem} positive>
              {t('Save')}
            </Button>
          </Modal.Actions>
        </div>
      </Modal>
    );
  }
}

export default withTranslation()(NewNMTrainingNameView);
